'use strict';

const initProduct = require('./product').init;
const renderPromoCode = require('./promoCode').renderPromoCode;
const renderCartTotals = require('./cartTotals').renderCartTotals;
const renderShippingCalculator = require('./shippingCalculator').renderShippingCalculator;
import {samples} from './samples';
import {giftWrap} from './giftWrap';
import { executeScriptsFromHTML } from 'app_custom_mufe_revamp/utilities/utils';

const cart = {
    elements: {
        $cartWrapper: $('.js-cart'),
        $miniCartWrapper: $('.js-mini-cart'),
        $body: $('body'),
        $jsBottom: $('.js-cart-modal .js-cart-bottom')
    },

    selectors: {
        cartDialog: '#cart-modal',
        cartContent: '.js-cart-content',
        productList: '.js-product-list',
        emptyCart: '.js-empty-cart',
        minicartQuantity : '.js-minicart-qty',
        cartQuantity: '.js-cart-modal .js-minicart-qty',
        squirrellyProducts: '#products',
        miniCartDialog: '#mini-cart-modal',
        renderRecommendations: '.js-cart-recommendations',
        renderEmptyCartRecommendations: '.js-cart-empty-cart-recommendations',
        applePayBtn: '#apple-pay-button',
        paypalContainer: '.paypal-container'
    },

    state: {
        cartGetUrl: null,
        updateQtyUrl: null,
        firstUpdateDone: false,
        cartRecommendationsUrl: null,
        cartEmptyRecommendationsUrl: null
    },

    init() {
        this.state.cartGetUrl = this.elements.$cartWrapper.attr('data-cart-get-url');
        this.state.cartRecommendationsUrl = this.elements.$cartWrapper.attr('data-cart-recommendations-url');
        this.state.cartEmptyRecommendationsUrl = this.elements.$cartWrapper.attr('data-cart-emptycartrecommendations-url');

        this.initEvent();
        this.handleCartRedirection();
        initProduct(this.handleApplePayButtonVisibility.bind(this));
        this.handleCloseApplePay();
    },

    initEvent() {
        this.elements.$cartWrapper.on('cart-update', this.onCartUpdate.bind(this));
        this.elements.$body.on('product:afterAddToCart', this.handleAfterAddToCart.bind(this));
        this.elements.$cartWrapper.on('cart-reset', this.getCartData.bind(this));
        $(this.selectors.cartDialog).on('dialog:open', this.handleDialogOpen.bind(this));
        $(this.selectors.cartDialog).on('dialog:close', this.handleDialogClose.bind(this));
        $(this.selectors.emptyCart).on('cart:showEmptyCart', this.handleEmptyCartRecommendations.bind(this));
        this.elements.$jsBottom.on('click', this.selectors.applePayBtn ,this.handleApplePayClick.bind(this));
    },

    //call this function each time dynamic component of the cart need to be updated (must be called by an event)
    onCartUpdate(_, cart) {
        const isEmpty = cart.numItems === 0;
        const cartQuantityContainer = $(this.selectors.cartQuantity);
        const productLabel = $(this.selectors.cartQuantity)[0]?.nextSibling;

        $(this.selectors.emptyCart).attr('hidden', !isEmpty).trigger('cart:showEmptyCart', {isEmpty});
        $(this.selectors.cartContent).attr('hidden', isEmpty);
        this.elements.$jsBottom.attr('hidden', isEmpty);

        $(this.selectors.minicartQuantity).text(cart.numItems);
        if(productLabel) {
                productLabel.textContent= cart.numItems <= 1 ? " " + cartQuantityContainer.data('productItem') : " " + cartQuantityContainer.data('productItems');
        }

        //Render products
        $(this.selectors.productList).morphBy({
            id: this.selectors.squirrellyProducts,
            squirrellyOptions: {
                items: (cart.items || []).filter(item => item?.category !== 'Samples' && !['GIFT_WRAP'].includes(item?.CORE_ITEMTYPE)),
                numItems: cart.numItems,
                applicableExpressPaymentMethods: cart.applicableExpressPaymentMethods
            },
            morphDomOptions: {
                morph: true,
                childrenOnly: true
            }
        });

        if (!isEmpty) {
            renderPromoCode(cart);
            renderCartTotals(cart);
            samples.renderSamples(cart);
            giftWrap.renderGiftWrap(cart);
            renderShippingCalculator(cart, $(this.selectors.cartDialog));
        }

        if (cart.numItems > 0) {
            this.renderRecommendationsSection(this.state.cartRecommendationsUrl, this.selectors.renderRecommendations);
        }else {
            $(this.selectors.renderRecommendations).html('');
        }

        if (!this.state.firstUpdateDone) {
            $(this.selectors.cartDialog).trigger('focus:reset');
            this.state.firstUpdateDone = true;
        }
    },

    handleEmptyCartRecommendations(_, state) {
        if (!state.isEmpty) return;
        this.renderRecommendationsSection(this.state.cartEmptyRecommendationsUrl, this.selectors.renderEmptyCartRecommendations);
    },

    handleAfterAddToCart(_, data) {
        const isCartOpen = $(this.selectors.cartDialog).attr('open');
        if (isCartOpen) {
            this.getCartData();
        } else {
            const isMiniCartOpen = $(this.selectors.miniCartDialog).attr('open');
            $(this.selectors.miniCartDialog).dialog({open: true});
            this.elements.$miniCartWrapper.trigger('minicart-update', {cart: data.cart, isMiniCartOpen: isMiniCartOpen});
        }
        if (window.dataLayer) {
            let addMethod = "product page";
            const $pdpSticky = $('#pdp-sticky-wrapper');
            const isProductPage = $('.page').data('action') === 'Product-Show';
            if ($pdpSticky.hasClass('fixed')) {
                addMethod = "sticky";
                $('html, body').scrollTop(0);
            } else if ($('#quickbuy').length) {
                addMethod = "quick buy";
            } else if (isProductPage) {
                if ($('.shadefinderWrapper').length) {
                    addMethod = "shade finder";
                } else if ($('.vto-dialog').length) {
                    addMethod = "virtual try on";
                }
            }
            var currencyCode = data.currencyCode != null ? data.currencyCode : "";
            var gtmData = data.gtmPush ? data.gtmPush : null;
            window.dataLayer.push({
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': currencyCode,
                    'add': {
                        'products': [gtmData]
                    }
                },
                'add_method': addMethod
            });
        }
    },

    getCartData() {
        if (!this.state.cartGetUrl) {
            console.warn('Cart Get url missing');
            return;
        }

        $.ajax({
            url: this.state.cartGetUrl,
            method: 'GET',
            success: (data) => {
                this.elements.$cartWrapper.trigger('cart-update', data);
                this.handleApplePayButtonVisibility();
                var isPaypalEnabled = document.getElementById("paypal_enabled") && document.getElementById("paypal_enabled").value ? true : false;
                if (isPaypalEnabled) {
                    init.initConfig(); // eslint-disable-line no-unused-vars
                    init.initPayPalButtons(); // // eslint-disable-line no-unused-vars
                    init.initFunctions(); // // eslint-disable-line no-unused-vars
                }
                if (data.checkoutOrderData && window.dataLayer) {
                    window.dataLayer.push(data.checkoutOrderData);
                }
            }
        });
    },

    handleApplePayButtonVisibility() {
        if (!window.ApplePaySession || !ApplePaySession.canMakePayments()) {
            $('.apple-pay-container').remove();
            if (!$(this.selectors.paypalContainer).hasClass('hide-paypal') && $(this.selectors.paypalContainer).length) {
                $(this.selectors.paypalContainer).removeClass('d-none');
            }
        }
    },

    handleDialogOpen(e) {
        if (e.target !== $(this.selectors.cartDialog).get(0)) {
            return;
        }
        this.getCartData();
    },

    handleDialogClose(e) {
        if (e.target !== $(this.selectors.cartDialog).get(0)) {
            return;
        }
        $(this.selectors.renderRecommendations).html('');
    },

    renderRecommendationsSection(url, template) {
        $.ajax({
            url: url,
            method: 'GET',
            success: (data) => {
                const cleanedHTML = executeScriptsFromHTML(data);
                $(template).html(cleanedHTML);
            }
        });
    },

    handleCartRedirection() {
        if (window.location.hash === '#showCart') {
            //Remove the anchor
            history.pushState(
                '',
                document.title,
                window.location.pathname + window.location.search
            );

            //Display the cart
            $(this.selectors.cartDialog).dialog({open: true});
        }
    },

    handleApplePayClick(e) {
        e.preventDefault();
        if (window.dataLayer) {
            let $applePayBtn = $('#apple-pay-button').closest('.js-checkout-option');
            window.dataLayer.push({
                event: 'checkoutExpress',
                checkoutOption: $applePayBtn.length > 0 ? $applePayBtn.attr('data-checkout-option') : ''
            });
        }
        $(this.selectors.cartDialog).dialog({open: false});
    },

    handleCloseApplePay() {
        window.addEventListener('apple-pay-close', function () {
            $('.js-minicart-btn').click();
        });
    }
};

cart.init();